import React from 'react';
import { ChartData, ScatterDataPoint } from 'chart.js';
import { Line } from 'react-chartjs-2';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

import ChartWrapper from './ChartWrapper';
import { useMetrics } from '../../Contexts/metrics-context';
import { getSnrPerSat } from '../../Utils/metricsSerializer';
import chartColors from './../../Constants/colors';
import defaultGraphOptions from './../../Constants/defaultGraphOptions';

export default function ChartSnrPerSat() {
  const { stateMetrics } = useMetrics();
  const [satellite, setSatellite] = React.useState('all');
  const [measureType, setMeasureType] = React.useState('all');

  const snrProcessedPerSat = React.useMemo(
    () => getSnrPerSat(stateMetrics.metricsOutput, stateMetrics.chartsFormat),
    [stateMetrics.metricsOutput, stateMetrics.chartsFormat],
  );

  /*eslint-disable */
  const data_: ChartData<
    'line',
    (number | ScatterDataPoint | null)[],
    unknown
  > = { datasets: [] };
  Object.keys(snrProcessedPerSat.data)
    .filter((key) => satellite === 'all' || key.includes(satellite))
    .filter((key) => measureType === 'all' || key.includes(measureType))
    .map((value, index) => {
      data_.datasets.push({
        type: 'line' as const,
        label: value,
        data: snrProcessedPerSat.data[value] as any,
        borderColor: chartColors.lineCharts.borders[index],
        backgroundColor: chartColors.lineCharts.backgrounds[index],
      });
    });
  /*eslint-enable */

  return (
    <React.Fragment>
      <ChartWrapper title="SNR per satellite">
        <div>
          <FormControl sx={{ m: 2, minWidth: 120 }} size="small">
            <InputLabel id="demo-select-small">Satellite</InputLabel>
            <Select
              value={satellite}
              size="small"
              label="Satellite"
              onChange={(e) => setSatellite(e.target.value)}
            >
              <MenuItem value="all">All</MenuItem>
              {snrProcessedPerSat.entities.map((value) => (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 2, minWidth: 120 }} size="small">
            <InputLabel id="demo-select-small">SNR Measures</InputLabel>
            <Select
              value={measureType}
              size="small"
              label="Type"
              onChange={(e) => setMeasureType(e.target.value)}
            >
              <MenuItem value="all">All</MenuItem>
              {snrProcessedPerSat.measuresTypes.map((value) => (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box style={{ height: '400px', margin: 'auto' }}>
            <Line options={defaultGraphOptions.line} data={data_} />
          </Box>
        </div>
      </ChartWrapper>
    </React.Fragment>
  );
}
